export enum PassportGroupTypeEnum {
  CANCELLATION = 'CANCELLATION',
  DELETION = 'DELETION',
}
